import React from 'react';

const TelemetryApp = () => {
  return (
    <div 
      className="w-full bg-black overflow-hidden flex flex-col"
      style={{ height: 'calc(100vh - 180px)' }}
    >
      <iframe
        src="https://eloquent-stroopwafel-53191d.netlify.app"
        className="w-full h-full border-none"
        title="Script Telemetry Command Center"
        allowFullScreen
      />
    </div>
  );
};

export default TelemetryApp;